export const ROUNDS_PER_GAME = 5;
export const MAX_ROUND_SCORE = 5000;
export const MAX_GAME_SCORE = ROUNDS_PER_GAME * MAX_ROUND_SCORE;

/** Guesses closer than this always earn the maximum score. */
export const PERFECT_RADIUS_KM = 0.025;

/** Scale of the world map: 1/10 of its reference diagonal (14 916.862 km). */
export const WORLD_SCALE_KM = 1491.6862;

/**
 * Points earned for a guess `distanceKm` away from the real location.
 *
 * Exponential decay like GeoGuessr: `5000 × e^(−d / scale)`, where `scale` is
 * a tenth of the size of the played map. A world guess 1 000 km off scores 2 558 points,
 * while on the France map (scale 120 km) it scores 1.
 */
export function scoreForDistance(distanceKm: number, scaleKm: number = WORLD_SCALE_KM): number {
  if (!Number.isFinite(distanceKm) || distanceKm < 0) return 0;
  if (distanceKm <= PERFECT_RADIUS_KM) return MAX_ROUND_SCORE;
  const score = Math.round(MAX_ROUND_SCORE * Math.exp(-distanceKm / Math.max(1, scaleKm)));
  return Math.max(0, Math.min(MAX_ROUND_SCORE, score));
}

/** Short French verdict shown on the round result screen. */
export function scoreVerdict(score: number): string {
  if (score >= 4990) return 'Parfait !';
  if (score >= 4500) return 'Exceptionnel !';
  if (score >= 3500) return 'Excellent !';
  if (score >= 2500) return 'Très bien';
  if (score >= 1500) return 'Pas mal';
  if (score >= 500) return 'Peut mieux faire';
  if (score > 0) return 'Raté…';
  return 'Aucun point';
}

/** Rank shown on the final screen. */
export function gameRank(total: number): string {
  const ratio = total / MAX_GAME_SCORE;
  if (ratio >= 0.95) return 'Légende de la géographie';
  if (ratio >= 0.8) return 'Explorateur chevronné';
  if (ratio >= 0.6) return 'Grand voyageur';
  if (ratio >= 0.4) return 'Globe-trotteur';
  if (ratio >= 0.2) return 'Touriste curieux';
  return 'Voyageur égaré';
}

export function formatScore(n: number): string {
  return new Intl.NumberFormat('fr-FR').format(Math.round(n));
}
